import NewFieldGrowersModal from '/@/views/dashboard/growers/components/new-field-modal';
import NewGrowersModalV2 from '/@/views/dashboard/growers/components/new-growers-modal-v2';
import type { FieldSelectState } from './use-field-select';

type FieldSelectModalsProps = Pick<
    FieldSelectState,
    | 'ownNodeQuery'
    | 'newFieldModalOpen'
    | 'setNewFieldModalOpen'
    | 'fieldModalGrowerUserNodeId'
    | 'newGrowersModalOpen'
    | 'setNewGrowersModalOpen'
    | 'handleGrowerSavedAndAddFields'
>;

function FieldSelectModals({
    ownNodeQuery,
    newFieldModalOpen,
    setNewFieldModalOpen,
    fieldModalGrowerUserNodeId,
    newGrowersModalOpen,
    setNewGrowersModalOpen,
    handleGrowerSavedAndAddFields,
}: FieldSelectModalsProps) {
    if (!ownNodeQuery.data?.id) return null;

    return (
        <>
            <NewFieldGrowersModal
                open={newFieldModalOpen}
                setOpen={setNewFieldModalOpen}
                rvUserNodeId={ownNodeQuery.data.id}
                growerUserNodeId={fieldModalGrowerUserNodeId}
                trackEntrySource='recommendation-create'
            />
            <NewGrowersModalV2
                open={newGrowersModalOpen}
                setOpen={setNewGrowersModalOpen}
                onAddFields={handleGrowerSavedAndAddFields}
                singleGrower
                entrySource='recommendation_create'
            />
        </>
    );
}

export default FieldSelectModals;
